// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Td6m","title":"ClientReferral_title__12cNO","itemText":"ClientReferral_itemText__3Z3a-"};